import { plural } from '@cian/utils';
import { partition } from 'ramda';

import { ICoworkingAmenity } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { coworkingAmenitiesGroups } from '../../../offer_card_page.commercial/otherCommercialCard/components/CoworkingAmenities/constants';

const [commonAmenities] = coworkingAmenitiesGroups;
const { availableAmenities } = commonAmenities;

export function getAmenitiesLabel(includedAmenities: ICoworkingAmenity[], elementsLength: number = 3) {
  const [common, addition]: ICoworkingAmenity[][] = partition(
    ({ key }) => availableAmenities.includes(key),
    includedAmenities,
  );

  const mergedArray = [...common, ...addition];
  const amenitiesLabel = mergedArray
    .slice(0, elementsLength)
    .map(({ title, key }) => {
      if (key !== 'wifi') {
        return title.toLowerCase();
      }

      return title;
    })
    .join(', ')
    .concat('...');
  const additionalAmenitites = mergedArray.slice(elementsLength).length;

  if (!additionalAmenitites) {
    return [amenitiesLabel];
  }

  const pluralizedAmenities = plural(additionalAmenitites, ['удобство', 'удобства', 'удобств']);
  const inlcudedLabel = plural(additionalAmenitites, ['включено', 'включены', 'включены']);

  return [amenitiesLabel, `+ ${additionalAmenitites} ${pluralizedAmenities} ${inlcudedLabel}`];
}
